import Icon from 'ui/components/Icon'

const ChecklistMenuActions = ({
  canTransfer,
  transferTargetLabel,
  onRename,
  onCopy,
  onMove,
  onDelete,
  close,
}) => (
  <>
    <button
      type="button"
      onClick={() => {
        onRename()
        close()
      }}
    >
      <Icon name="edit" size={16} />
      <span>Переименовать</span>
    </button>
    {canTransfer && (
      <button
        type="button"
        onClick={() => {
          onCopy()
          close()
        }}
      >
        <Icon name="copy" size={16} />
        <span>Копировать в {transferTargetLabel}</span>
      </button>
    )}
    {canTransfer && (
      <button
        type="button"
        onClick={() => {
          onMove()
          close()
        }}
      >
        <Icon name="transfer-menu" size={16} />
        <span>Переместить в {transferTargetLabel}</span>
      </button>
    )}

    <button
      type="button"
      onClick={() => {
        onDelete()
        close()
      }}
    >
      <Icon name="trash" size={16} />
      <span>Удалить</span>
    </button>
  </>
)

export default ChecklistMenuActions
